(function () {
  var returnFocus = null;
  var focusPlan = null;
  var queue = Promise.resolve();
  var generation = 0;

  function rootUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function drawer() {
    return document.querySelector('bm-cart-drawer');
  }

  function sectionId() {
    var el = drawer();
    return (el && el.getAttribute('data-section-id')) || 'cart-drawer';
  }

  function enqueue(task) {
    queue = queue.then(task, task);
    return queue;
  }

  function setExpanded(open) {
    document.querySelectorAll('[data-bm-cart]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function finishClose(el, token) {
    if (token !== generation) return;
    if (!el || el !== drawer() || el.classList.contains('is-open')) return;
    el.classList.remove('is-opening');
    el.setAttribute('inert', '');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bm-cart-open');
    setExpanded(false);
    if (returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus();
    }
    returnFocus = null;
  }

  function openDrawer(trigger) {
    var el = drawer();
    if (!el) return;
    var token = ++generation;
    if (trigger) returnFocus = trigger;
    el.removeAttribute('inert');
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-opening');
    document.body.classList.add('bm-cart-open');
    setExpanded(true);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (token !== generation) return;
        el.classList.add('is-open');
        focusDrawer(el);
      });
    });
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    if (!el.classList.contains('is-open') && !el.classList.contains('is-opening')) return;
    var token = ++generation;
    el.classList.remove('is-open');
    var panel = el.querySelector('.bm-cart__panel');
    var done = false;
    function finish(event) {
      if (done || token !== generation) return;
      if (event && event.target !== panel) return;
      if (event && event.propertyName !== 'transform') return;
      done = true;
      finishClose(el, token);
    }
    if (panel) panel.addEventListener('transitionend', finish);
    window.setTimeout(function () {
      finish();
    }, 320);
  }

  function focusDrawer(el) {
    if (!el) return;
    if (focusPlan && focusPlan.type === 'qty') {
      var row = el.querySelector('[data-line-key="' + CSS.escape(focusPlan.key) + '"]');
      var target = row && row.querySelector('[data-bm-qty-part="' + focusPlan.part + '"]');
      if (target) {
        target.focus();
        return;
      }
    }
    var closeButton = el.querySelector('[data-bm-cart-header-close]');
    if (closeButton) closeButton.focus();
  }

  function fallbackError() {
    var el = drawer();
    return (el && el.getAttribute('data-error-message')) || 'Could not update your cart';
  }

  function showError(message) {
    var el = drawer();
    if (!el) return;
    var error = el.querySelector('[data-bm-cart-error]');
    if (!error) return;
    error.hidden = false;
    error.textContent = message || fallbackError();
  }

  function clearError(el) {
    var error = el && el.querySelector('[data-bm-cart-error]');
    if (!error) return;
    error.hidden = true;
    error.textContent = '';
  }

  function applySectionHtml(html, options) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('bm-cart-drawer');
    var current = drawer();
    if (!next || !current) return;

    var wasOpen = current.classList.contains('is-open') || current.classList.contains('is-opening');
    var shouldOpen = options.open || wasOpen;
    if (current.classList.contains('is-busy')) next.classList.add('is-busy');
    if (options.trigger) returnFocus = options.trigger;

    if (shouldOpen) {
      next.removeAttribute('inert');
      next.setAttribute('aria-hidden', 'false');
      next.classList.add('is-opening');
      if (wasOpen) next.classList.add('is-open');
      document.body.classList.add('bm-cart-open');
      setExpanded(true);
    }

    current.replaceWith(next);

    if (shouldOpen && !wasOpen) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          next.classList.add('is-open');
          if (options.focus) focusDrawer(next);
        });
      });
      return;
    }

    if (options.focus) focusDrawer(next);
  }

  function sectionFromResponse(data) {
    if (!data || !data.sections) return '';
    return data.sections[sectionId()] || '';
  }

  function readError(response) {
    return response
      .json()
      .catch(function () {
        return null;
      })
      .then(function (data) {
        if (data && data.description) return data.description;
        if (data && data.message) return data.message;
        return fallbackError();
      });
  }

  function refreshSection(options) {
    var url = rootUrl() + '?section_id=' + encodeURIComponent(sectionId());
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('section');
        return response.text();
      })
      .then(function (html) {
        applySectionHtml(html, options);
      });
  }

  function postCart(url, init, options) {
    var el = drawer();
    if (el) el.classList.add('is-busy');
    return fetch(url, init)
      .then(function (response) {
        if (!response.ok) {
          return readError(response).then(function (message) {
            return refreshSection({ open: true, focus: true, trigger: options.trigger || null })
              .catch(function () {})
              .then(function () {
                showError(message);
                if (!drawer() || !drawer().classList.contains('is-opening')) {
                  openDrawer(options.trigger || null);
                }
                throw new Error(message);
              });
          });
        }
        return response.json();
      })
      .then(function (data) {
        var html = sectionFromResponse(data);
        if (html) {
          applySectionHtml(html, options);
          return;
        }
        return refreshSection(options);
      })
      .finally(function () {
        var current = drawer();
        if (current) current.classList.remove('is-busy');
      });
  }

  function changeLine(key, quantity, part, trigger) {
    focusPlan = { type: 'qty', key: key, part: part || 'input' };
    return enqueue(function () {
      return postCart(
        rootUrl() + 'cart/change.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: sectionId(),
            sections_url: window.location.pathname,
          }),
        },
        { open: true, focus: true, trigger: trigger }
      );
    });
  }

  function quantityFromInput(input) {
    var parsed = parseInt(input.value, 10);
    if (!isFinite(parsed) || parsed < 0) return null;
    return parsed;
  }

  function lineKeyFrom(target) {
    var row = target.closest('[data-line-key]');
    return row ? row.getAttribute('data-line-key') : '';
  }

  function onClick(event) {
    var el = drawer();
    if (!el || !el.contains(event.target)) return;

    if (event.target.closest('[data-bm-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var qtyButton = event.target.closest('[data-bm-qty-delta]');
    if (!qtyButton) return;
    var row = qtyButton.closest('[data-line-key]');
    var input = row && row.querySelector('[data-bm-qty-part="input"]');
    if (!input) return;
    var current = quantityFromInput(input);
    if (current === null) current = parseInt(input.getAttribute('data-qty') || '1', 10) || 1;
    var next = Math.max(0, current + Number(qtyButton.getAttribute('data-bm-qty-delta')));
    input.value = String(next);
    changeLine(lineKeyFrom(qtyButton), next, qtyButton.getAttribute('data-bm-qty-part'), null);
  }

  function onChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-bm-qty-part="input"]')) return;
    var next = quantityFromInput(input);
    if (next === null) {
      input.value = input.getAttribute('data-qty') || '1';
      return;
    }
    changeLine(lineKeyFrom(input), next, 'input', null);
  }

  function onKeydown(event) {
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-bm-qty-part="input"]')) {
      event.preventDefault();
      event.target.blur();
      return;
    }

    if (event.key === 'Escape') {
      var open = drawer();
      if (open && open.classList.contains('is-open')) {
        event.preventDefault();
        closeDrawer();
      }
      return;
    }

    if (event.key !== 'Tab') return;
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    var panel = el.querySelector('.bm-cart__panel');
    if (!panel) return;
    var focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function isAddToCartSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return false;
    if (event.submitter) return event.submitter.matches('[data-add-to-cart-button]');
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/.test(action) && !!form.querySelector('[data-add-to-cart-button]');
  }

  function addFromForm(form, submitter) {
    var formData = new FormData(form);
    formData.set('sections', sectionId());
    formData.set('sections_url', window.location.pathname);
    focusPlan = { type: 'close' };
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    return enqueue(function () {
      return postCart(
        rootUrl() + 'cart/add.js',
        {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        },
        { open: true, focus: true, trigger: submitter || null }
      );
    }).finally(function () {
      if (!submitter) return;
      submitter.disabled = false;
      submitter.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bm-cart]');
    if (!trigger) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    focusPlan = { type: 'close' };
    var el = drawer();
    if (el) clearError(el);
    openDrawer(trigger);
  });

  document.addEventListener('submit', function (event) {
    if (!isAddToCartSubmit(event)) return;
    event.preventDefault();
    addFromForm(event.target, event.submitter);
  });

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('keydown', onKeydown);

  if (!customElements.get('bm-cart-drawer')) {
    customElements.define(
      'bm-cart-drawer',
      class extends HTMLElement {}
    );
  }
})();
